import { Box, BoxProps, ColorOptions, IconNew, TextNew, TextNewProps } from '@jfs/ui-new'

interface SubscriptionInfoAlertInterface {
  hide?: boolean
}

export const SubscriptionInfoAlert = ({ hide }: SubscriptionInfoAlertInterface) => {
  if (hide) {
    return null
  } else {
    return (
      <Box {...styles.boxWrapper}>
        <IconNew id="INFO" size="MEDIUM" color={'MUD_YELLOW_DARK' as ColorOptions} />
        <Box justifyContent="center" pl={10}>
          <TextNew type="body12" color={'MUD_YELLOW_DARK' as ColorOptions} textAlign="center">
            {'Paused by Customer on'} <TextNew {...styles.boldText}>{'30 Jun 2020'}</TextNew>
            {' (#RFID12345678) till'} <TextNew {...styles.boldText}>{'30 Jun 2020'}</TextNew>
          </TextNew>
        </Box>
      </Box>
    )
  }
}

const styles = {
  boldText: {
    type: 'body12',
    fontWeight: 'FONT_WEIGHT_BOLD',
    color: 'MUD_YELLOW_DARK' as ColorOptions,
    textAlign: 'center',
  } as TextNewProps,
  boxWrapper: {
    flexDirection: 'row',
    ph: 16,
    pv: 5,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: 'WASHED_YELLOW' as ColorOptions,
    bg: 'WASHED_YELLOW_LIGHT' as ColorOptions,
  } as BoxProps,
}
